import script from "./CardDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./CardDevice.vue?vue&type=script&setup=true&lang=js"

import "./CardDevice.vue?vue&type=style&index=0&id=053fd74f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-053fd74f"]])

export default __exports__